import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCarouselItem]',
  standalone: true,
})
export class CarouselItemDirective {
  //this directive is used with the shared component carousel
  //used to add the items to the carousel and track the items
  constructor(public el: ElementRef<HTMLElement>) {}
}
